export default __webpack_public_path__ + "static/react-7a5681bb7e6e66a43dc7d53345864372.svg";